import { createSlice } from '@reduxjs/toolkit';

import { getQCInwardData, inwardBox, getInwardedBoxes, bulkUploadInwardBoxes, getQcModal, verifyQuantity, verifyQCInspection, shipToIndiaSummary, returnToVendorSummary, confirmShipToIndia, confirmReturnToVendor, getReviewCommentMeta, uploadQcInspectionQuantity, uploadQuantityValidation, uploadReviewImage, uploadInwardBoxes, uploadBulkPackingList, createReadyForInvoice, skipQCInspection, inwardBoxToShelf, uploadBulkShippingLabels, revertBoxToQc, revertQualityInspection } from '../../apis';

export const QCPlatform = createSlice({

    name: 'qcPlatform',
    initialState: {
        qcInwardData: [],
        loading: '',
        error: '',
        qcData: [],
        inwardSuccess: '',
        getQcModalData: [],
        getQcModalSuccess: false,
        verifyQuantitySuccess: false,
        verifyQCInspectionSuccess: false,
        returnToVendorSummaryData: {},
        shipToIndiaSummaryData: {},
        confirmShipToIndiaSuccess: false,
        confirmReturnToVendorSuccess: false,
        getReviewCommentMetaData: [],
        uploadQcInspectionQuantitySuccess: false, 
        uploadQuantityValidationSuccess: false,
        uploadReviewImageSuccess: false,
        uploadInwardBoxesSuccess: false,
        uploadBulkPackingListSuccess: false,
        uploadBulkPackingListData: '',
        readyForInvoiceSuccess: false,
        skipQCInspectionSuccess: false,
        inwardToShelfSuccess: false,
        downloadShippingLabelsUrl: '',
        uploadShippingLabelFileSuccess: false,
        getBulkUploadInwardBoxesData : [],
        revertToQcPendingSuccess: false,
        revertQualityInspectionSuccess : false
    },
    reducers: {
        clearInwardSuccess: (state, action) => {
            return {
                ...state,
                inwardSuccess: action.payload
            }
        },
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearVerifyQuantitySuccess: (state, action) => {
            return {
                ...state,
                verifyQuantitySuccess: action.payload
            }
        },
        clearVerifyQCInspectionSuccess: (state, action) => {
            return {
                ...state,
                verifyQCInspectionSuccess: action.payload
            }
        },
        updateUploadQuantityValidationSuccess: (state, action) => {
            return {
                ...state, 
                uploadQuantityValidationSuccess: action.payload
            }
        },
        updateUploadQcInspectionQuantitySuccess: (state, action) => {
            return {
                ...state, 
                uploadQcInspectionQuantitySuccess: action.payload
            }
        },
        clearGetReviewCommentMetaData: (state, action) => {
            return {
                ...state, 
                getReviewCommentMetaData: action.payload
            }
        },
        clearUploadReviewImageSuccess: (state, action) => {
            return {
                ...state, 
                uploadReviewImageSuccess: action.payload
            }
        },
        clearConfirmReturnToVendorSuccess: (state, action) => {
            return {
                ...state, 
                confirmReturnToVendorSuccess: action.payload
            }
        },
        clearConfirmShipToIndiaSuccess: (state, action) => {
            return {
                ...state, 
                confirmShipToIndiaSuccess: action.payload
            }
        },
        clearShipToIndiaSummaryData: (state, action) => {
            return {
                ...state, 
                shipToIndiaSummaryData: action.payload
            }
        },
        clearUploadInwardBoxesSuccess: (state, action) => {
            return {
                ...state, 
                uploadInwardBoxesSuccess: action.payload
            }
        },
        clearUploadBulkPackingListSuccess: (state, action) => {
            return {
                ...state, 
                uploadBulkPackingListSuccess: action.payload
            }
        },
        clearGetQcModalData: (state, action) => {
            return {
                ...state, 
                getQcModalData: action.payload
            }
        },
        clearGetQcModalSuccess: (state, action) => {
            return {
                ...state, 
                getQcModalSuccess: action.payload
            }
        },
        clearReadyForInvoiceSuccess: (state, action) => {
            return {
                ...state,
                readyForInvoiceSuccess: action.payload
            }
        },
        clearSkipQCInspectionSuccess: (state, action) => {
            return {
                ...state,
                skipQCInspectionSuccess: action.payload
            }
        },
        clearRevertToQcPendingSuccess: (state, action) => {
            return {
                ...state,
                revertToQcPendingSuccess: action.payload
            }
        },
        clearRevertQualityInspectionSuccess: (state, action) => {
            return {
                ...state,
                revertQualityInspectionSuccess: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getQCInwardData.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getQCInwardData.fulfilled, (state, action) => {
            state.loading = false;
            state.qcInwardData = action.payload.data
            
        })
        builder.addCase(getQCInwardData.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(inwardBox.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(inwardBox.fulfilled, (state, action) => {
            state.loading = false;
            state.inwardSuccess = action.payload.data
        })
        builder.addCase(inwardBox.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getInwardedBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getInwardedBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.qcData = action.payload.data
        })
        builder.addCase(getInwardedBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getQcModal.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getQcModal.fulfilled, (state, action) => {
            state.loading = false;
            state.getQcModalData = action.payload.data
            state.getQcModalSuccess = true
        })
        builder.addCase(getQcModal.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(verifyQuantity.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(verifyQuantity.fulfilled, (state, action) => {
            state.loading = false;
            state.verifyQuantitySuccess = true
        })
        builder.addCase(verifyQuantity.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(verifyQCInspection.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(verifyQCInspection.fulfilled, (state, action) => {
            state.loading = false;
            state.verifyQCInspectionSuccess = true
        })
        builder.addCase(verifyQCInspection.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(returnToVendorSummary.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(returnToVendorSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.returnToVendorSummaryData = action.payload
            state.error = false
        })
        builder.addCase(returnToVendorSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(shipToIndiaSummary.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(shipToIndiaSummary.fulfilled, (state, action) => {
            state.loading = false;
            state.shipToIndiaSummaryData = action.payload
            state.error = false
        })
        builder.addCase(shipToIndiaSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(confirmShipToIndia.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(confirmShipToIndia.fulfilled, (state, action) => {
            state.loading = false;
            state.confirmShipToIndiaSuccess = true
        })
        builder.addCase(confirmShipToIndia.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(confirmReturnToVendor.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(confirmReturnToVendor.fulfilled, (state, action) => {
            state.loading = false;
            state.confirmReturnToVendorSuccess = true
        })
        builder.addCase(confirmReturnToVendor.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getReviewCommentMeta.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getReviewCommentMeta.fulfilled, (state, action) => {
            state.loading = false;
            state.getReviewCommentMetaData = action.payload
            state.error = false
        })
        builder.addCase(getReviewCommentMeta.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadQcInspectionQuantity.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadQcInspectionQuantity.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadQcInspectionQuantitySuccess = true
            state.error = false
        })
        builder.addCase(uploadQcInspectionQuantity.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadQuantityValidation.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadQuantityValidation.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadQuantityValidationSuccess = true
            state.error = false
        })
        builder.addCase(uploadQuantityValidation.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadReviewImage.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadReviewImage.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadReviewImageSuccess = true
            state.error = false
        })
        builder.addCase(uploadReviewImage.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadInwardBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadInwardBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadInwardBoxesSuccess = true
            state.error = false
        })
        builder.addCase(uploadInwardBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadBulkPackingList.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadBulkPackingList.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadBulkPackingListSuccess = true
            state.uploadBulkPackingListData = action.payload.data
            state.error = false
        })
        builder.addCase(uploadBulkPackingList.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(createReadyForInvoice.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createReadyForInvoice.fulfilled, (state, action) => {
            state.loading = false;
            state.readyForInvoiceSuccess = true
            state.error = false
        })
        builder.addCase(createReadyForInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(skipQCInspection.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(skipQCInspection.fulfilled, (state, action) => {
            state.loading = false;
            state.skipQCInspectionSuccess = true
        })
        builder.addCase(skipQCInspection.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(inwardBoxToShelf.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(inwardBoxToShelf.fulfilled, (state, action) => {
            state.loading = false;
            state.inwardToShelfSuccess = true
        })
        builder.addCase(inwardBoxToShelf.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadBulkShippingLabels.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadBulkShippingLabels.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadShippingLabelFileSuccess = true;
            state.downloadShippingLabelsUrl = action.payload.data
        })
        builder.addCase(uploadBulkShippingLabels.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })

        builder.addCase(bulkUploadInwardBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(bulkUploadInwardBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.getBulkUploadInwardBoxesData = action.payload.data
        })
        builder.addCase(bulkUploadInwardBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(revertBoxToQc.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(revertBoxToQc.fulfilled, (state, action) => {
            state.loading = false;
            state.revertToQcPendingSuccess = true
            state.error = false
        })
        builder.addCase(revertBoxToQc.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(revertQualityInspection.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(revertQualityInspection.fulfilled, (state, action) => {
            state.loading = false;
            state.error = '';
            state.revertQualityInspectionSuccess = true;
        })
        builder.addCase(revertQualityInspection.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }

})

export const {clearInwardSuccess, clearError, clearVerifyQuantitySuccess, clearVerifyQCInspectionSuccess, updateUploadQuantityValidationSuccess, updateUploadQcInspectionQuantitySuccess, clearGetReviewCommentMetaData, clearUploadReviewImageSuccess, clearConfirmReturnToVendorSuccess, clearConfirmShipToIndiaSuccess, clearUploadInwardBoxesSuccess, clearUploadBulkPackingListSuccess, clearGetQcModalData, clearGetQcModalSuccess, clearShipToIndiaSummaryData, clearReadyForInvoiceSuccess, clearSkipQCInspectionSuccess, revertToQcPendingSuccess, clear, clearRevertQualityInspectionSuccess} = QCPlatform.actions

export default QCPlatform.reducer